import React from 'react';
import R from 'ramda';
import moment from 'moment';

const ChangeStatus = ({
  dealUsers,
  deal,
  invites,
  finalized,
  dealUser,
  userStatus,
  handleUserStatus,
}) => {
  if (deal && dealUsers && invites) {
    return (
      <div className="user-status">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {invites.map((invite, i) => {
              if (invite.type === 'member' && deal.id === invite.deal) {
                let member = null;
                if (invite.invitee) {
                  member = R.find(
                    R.whereEq({ user: invite.invitee, type: 'member' })
                  )(dealUsers);
                }

                return member ? (
                  <tr key={i}>
                    <td>{invite.name}</td>
                    <td>
                      {finalized && dealUser && dealUser.id === member.id ? (
                        <select value={userStatus} onChange={handleUserStatus}>
                          <option value="">Status update</option>
                          <option value="Reviewing">Reviewing</option>
                          <option value="Accepted">
                            {userStatus === 'Accepted' ? 'Signed' : 'Sign'}
                          </option>
                        </select>
                      ) : member ? (
                        member.status === 'Accepted' ? (
                          'Signed'
                        ) : (
                          member.status || 'Reviewing'
                        )
                      ) : (
                        'Reviewing'
                      )}
                    </td>
                    <td>
                      {member &&
                      member.status === 'Accepted' &&
                      member.date_accepted
                        ? moment(member.date_accepted).format('MM/DD/YYYY')
                        : ''}
                    </td>
                  </tr>
                ) : (
                  <tr key={i}>
                    <td>{invite.name}</td>
                    <td>Inviting</td>
                    <td>&nbsp;</td>
                  </tr>
                );
              } else {
                return null;
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
};

export default ChangeStatus;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/ChangeStatus.js